import {create} from "zustand";
import { ProductsAPI } from "../Helpers/ConfigProvider";

const useHighLightsStore = create((set) => ({
    highlights: [],
    loading: false,
    error: null,
    fetchHighlights: async () => {

        if (set.loading) return; // Prevent multiple simultaneous fetches

        set({ loading: true, error: null });
        try {
            const response = await fetch(`${ProductsAPI}/Highlights`);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || "Failed to fetch highlights");
            }
            const data = await response.json();
            set({ highlights: data, loading: false });
        } catch (error) {
            set({ loading: false });
        }
    },
}));

export default useHighLightsStore;